import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
    document.title = "404 - Page Not Found | Spilios Spiliopoulos";
  }, [location.pathname]);

  return (
    <main className="flex min-h-screen items-center justify-center px-6 bg-background relative overflow-hidden">
      {/* Decorative glow */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent/10 rounded-full blur-3xl" />

      <div className="text-center space-y-6 relative z-10 max-w-xl">
        <h1 className="text-7xl md:text-9xl font-bold">
          <span className="text-violet-400 [text-shadow:0_0_40px_rgba(167,139,250,0.8)]">
            4
          </span>
          <span className="text-violet-400 [text-shadow:0_0_40px_rgba(167,139,250,0.8)]">
            0
          </span>
          <span className="text-violet-400 [text-shadow:0_0_40px_rgba(167,139,250,0.8)]">
            4
          </span>
        </h1>

        <h2 className="text-2xl md:text-3xl font-semibold text-foreground">
          Page Not Found
        </h2>

        <p className="text-lg text-muted-foreground leading-relaxed">
          The page you're looking for doesn't exist or has been moved.
          Head back to the homepage to explore Spilios Spiliopoulos' portfolio.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <Button
            asChild
            size="lg"
            className="shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 bg-gradient-to-r from-violet-600 to-indigo-600 hover:from-violet-700 hover:to-indigo-700 border-0 text-white"
          >
            <a href="/" aria-label="Return to homepage">
              <Home className="mr-2 w-5 h-5" />
              Return Home
            </a>
          </Button>
          <Button
            asChild
            variant="outline"
            size="lg"
            className="border-2 border-primary/30 hover:border-primary/60 hover:scale-105 transition-all"
          >
            <a href="/#projects" aria-label="View featured projects">
              <ArrowLeft className="mr-2 w-5 h-5" />
              View Projects
            </a>
          </Button>
        </div>

        <nav aria-label="Quick links" className="pt-8 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
          <a href="/#about" className="hover:text-primary transition-colors">About</a>
          <a href="/#projects" className="hover:text-primary transition-colors">Projects</a>
          <a href="/#experience" className="hover:text-primary transition-colors">Experience</a>
          <a href="/#contact" className="hover:text-primary transition-colors">Contact</a>
        </nav>
      </div>
    </main>
  );
};

export default NotFound;
